import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface CreatorSpotlightProps {
  creator: {
    name: string;
    region: string;
    language: string;
    image: string;
    alt: string;
    storiesCount: number;
    followers: number;
    specialty: string;
    quote: string;
  };
}

export default function CreatorSpotlight({ creator }: CreatorSpotlightProps) {
  return (
    <div className="bg-card rounded-xl p-6 shadow-warm hover:shadow-warm-lg transition-all duration-300">
      <div className="flex items-start space-x-4 mb-4">
        <div className="relative w-20 h-20 rounded-full overflow-hidden flex-shrink-0 ring-4 ring-primary/20">
          <AppImage
            src={creator.image}
            alt={creator.alt}
            className="w-full h-full object-cover"
          />
        </div>
        <div className="flex-1">
          <h4 className="text-lg font-heading font-bold text-text-primary mb-1">
            {creator.name}
          </h4>
          <p className="text-sm text-muted-foreground mb-2">
            {creator.region} • {creator.language}
          </p>
          <div className="flex items-center space-x-4">
            <span className="text-xs text-text-secondary flex items-center">
              <Icon name="BookOpenIcon" size={14} className="mr-1 text-primary" />
              {creator.storiesCount} Stories
            </span>
            <span className="text-xs text-text-secondary flex items-center">
              <Icon name="UserGroupIcon" size={14} className="mr-1 text-secondary" />
              {creator.followers.toLocaleString('en-IN')} Followers
            </span>
          </div>
        </div>
      </div>

      <div className="mb-4 p-3 bg-muted rounded-lg">
        <p className="text-xs text-muted-foreground mb-1 font-semibold uppercase tracking-wide">
          Specialty
        </p>
        <p className="text-sm text-text-primary font-medium">{creator.specialty}</p>
      </div>

      <div className="relative">
        <Icon
          name="ChatBubbleLeftIcon"
          size={24}
          className="absolute -top-2 -left-2 text-accent opacity-30"
        />
        <p className="text-sm text-text-secondary italic pl-6">"{creator.quote}"</p>
      </div>
    </div>
  );
}